import { render, staticRenderFns } from "./CoTwoAccomodationForm.vue?vue&type=template&id=e19442d4&scoped=true&"
import script from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
import style0 from "./CoTwoAccomodationForm.vue?vue&type=style&index=0&id=e19442d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19442d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e19442d4')) {
      api.createRecord('e19442d4', component.options)
    } else {
      api.reload('e19442d4', component.options)
    }
    module.hot.accept("./CoTwoAccomodationForm.vue?vue&type=template&id=e19442d4&scoped=true&", function () {
      api.rerender('e19442d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoAccomodationForm.vue"
export default component.exports